export class PowerBIReport {
    id: number;
    reportName: string;
    biReportName: string;
    icon: string;
    isEnabled: boolean;
    displaySequence: number;
    enableRLS: boolean;
    roles: string;
    reportType: number;
    subTitle: string;

    constructor() {
        this.id = 0;
        this.reportName = '';
        this.biReportName = '';
        this.icon = '';
        this.isEnabled = false;
        this.displaySequence = 0;
        this.enableRLS = false;
        this.roles = '';
        this.reportType = 1;
        this.subTitle = '';
    }
}